module.exports = __webpack_public_path__ + "static/media/financial.8b386c0a.png";